/*
 * Module that handles displaying the user's Tableau workbooks
 */

define([
  "marionette",
  "backbone",
  "jquery",
  "messaging/messenger",
  "modules/reportSplit/groups/adHocWorkbooks/adHocWorkbooksView",
  "modules/shared/sortableList/sortableListModule",
  "modules/reportSplit/groups/adHocWorkbooks/adHocWorkbooksModal/adHocWorkbooksModalModule",
  "modules/reportSplit/groups/adHocWorkbooks/adHocWorkbooksModel",
], function (
  Marionette,
  Backbone,
  $,
  Messenger,
  AdHocWorkbooksView,
  SortableListModule,
  AdHocWorkbooksModalModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "adHocWorkbooksModule";
      this.region = options.region;
      this._setUpVents();
    },
    show: function () {
      this.workbooks = Messenger.reqres.request("adHoc:workbooks");
      const adHocAdmin = Messenger.reqres.request("user:is:adhoc:admin");
      const adHocModel = new Backbone.Model({
        adHocAdmin: adHocAdmin,
      });
      this.layout = new AdHocWorkbooksView.adHocWorkbooksLayout({ model: adHocModel });
      const headers = Messenger.reqres.request("adHoc:workbook:headers");

      const extendedEvents = {
        "click #deleteWorkbook": function () {
          Messenger.yesNoDialog(
            "reports.adHoc.workbooks.confirmDeleteWorkbook",
            {
              yes: function () {
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete Ad Hoc Workbook",
                  id: this.model.id,
                  idType: "Ad Hoc Workbook",
                  object: "Ad Hoc Workbook",
                });
                this.model.deleteModel();
              },
            },
            this,
          );
        },
      };

      this.list = this.addSubModule(
        new SortableListModule({
          region: this.layout.list,
          headers: headers,
          namespace: this.name,
          recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
          extendedEvents: extendedEvents,
        }),
      );

      this.layout.on(
        "add:workbook",
        function () {
          const newItem = this.workbooks.addItem();
          Messenger.vent.trigger("show:modal", AdHocWorkbooksModalModule, {}, newItem, {
            title: "reports.adHoc.workbooks.addWorkbook",
            closeButton: false,
            closeOnBackgroundClick: false,
            modalWidth: 400,
            trackInteraction: {
              action: "Add Ad Hoc Workbook",
              object: "Ad Hoc Workbook",
            },
          });
        },
        this,
      );

      this.layout.on(
        "show",
        function () {
          this.list.show(this.workbooks);
        },
        this,
      );
      this.showRegion(this.layout);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "show:adHoc:workbooks",
        function () {
          this.show();
        },
        this,
      );

      Messenger.vent.on(
        this.name + ":selected:row",
        function (model) {
          const workbookUrl = Messenger.reqres.request("adHoc:workbook:url", model);
          workbookUrl.onSynced(function () {
            Messenger.vent.trigger("show:adHoc:report", workbookUrl.get("value"));
          }, this);
        },
        this,
      );
    },
  });
});
